/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { Lock } from "lucide-react";
import TextInput from "../ui/TextInput";
import { SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Button from "../ui/Button";
import AuthPageWrapper from "./AuthPageWrapper";
import { resetPasswordSchema } from "./auth_schemas"; // Schema for validation
import { ResetPasswordFormInputs } from "./auth_types"; // Type for form inputs
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../redux/app/hooks";
import { changeAdminPasswordAsync } from "../../redux/features/adminSlice";
import { resetUnAuthorizedForgotPassword } from "../../redux/features/authSlice";

const ResetPasswordPage: React.FC = () => {
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ResetPasswordFormInputs>({
    resolver: yupResolver(resetPasswordSchema),
  });
  const { unAuthorizedForgotPassword } = useAppSelector((state) => state.auth);
  const [resetingPassword, setResetingPassword] = useState(false);
  const dispatch = useAppDispatch();

  const handlePasswordReset = async (data: any) => {
    setResetingPassword(true);
    try {
      await dispatch(
        changeAdminPasswordAsync({
          parameters: {
            ...unAuthorizedForgotPassword,
            newPassword: data?.password,
          },
          isAuthenticated: false,
        })
      ).unwrap();
      navigate("/forgot-password/success");
      setResetingPassword(false);
      dispatch(resetUnAuthorizedForgotPassword());
    } catch (err) {
      setResetingPassword(false);
    }
  };

  const onSubmit: SubmitHandler<ResetPasswordFormInputs> = (data, event) => {
    event?.preventDefault();
    handlePasswordReset(data);
  };

  return (
    <AuthPageWrapper
      title="Create new password"
      sub_title="Enter your new password to reset your account"
    >
      <form
        className="space-y-4 w-full md:w-[450px]"
        onSubmit={handleSubmit(onSubmit)}
      >
        <TextInput
          id="password"
          type="password"
          label="New Password"
          placeholder="Enter your new password"
          icon={<Lock className="w-5 h-5 text-gray-400" />}
          error={errors.password?.message}
          register={register("password")}
        />
        <Button
          label="Reset Password"
          type="submit"
          isLoading={resetingPassword}
        />
      </form>
    </AuthPageWrapper>
  );
};

export default ResetPasswordPage;
